"use client";
import Image from "next/image";
import Link from "next/link";
import { BLOCK_EXPLORER_URL } from "../constants";
import { KOLZ_TOKEN_SYMBOL } from "../uniswap/constants";
import PriceChart from "./PriceChart";
interface KolPriceWidgetProps {
  tokenSymbol: string;
  poolAddress: string;
  tokenAddress: string;
}

export default function KolPriceWidget({ tokenSymbol, poolAddress, tokenAddress }: KolPriceWidgetProps) {
  return (
    <div className="bg-[#161b22] rounded-lg p-3 sm:p-4 shadow-lg mb-6">
      <div className="flex mb-3">
        <div className="flex-1">
          <h2 className="text-lg sm:text-xl font-semibold mb-2">
            ${tokenSymbol}/${KOLZ_TOKEN_SYMBOL}
          </h2>
          <div className="text-sm sm:text-base">
            <p className="text-gray-400 text-xs sm:text-sm mb-1">
              Address:{" "}
              <Link
                href={`${BLOCK_EXPLORER_URL}token/${tokenAddress}`}
                target="_blank"
                className="text-blue-400 hover:text-blue-300 break-all"
              >
                {tokenAddress}
              </Link>
            </p>
            <p className="text-gray-400 text-xs sm:text-sm">Network: Base</p>
          </div>
        </div>
        <div className="flex items-center ml-4">
          <Image
            src={`/token_logos/${tokenSymbol.toLowerCase()}.png`}
            alt={`${tokenSymbol} token logo`}
            width={64}
            height={64}
          />
        </div>
      </div>

      <div>
        <PriceChart poolAddress={poolAddress} token0Symbol={tokenSymbol} />
      </div>
    </div>
  );
}
